'use client';

import * as React from 'react';
import type { CityCode } from '@loci/city-editions';

import { useDiscoverHref } from '@/hooks/useDiscoverHref';

import { SurfaceLink, type SurfaceLinkProps } from './SurfaceLink';

export type DiscoverLinkProps = Omit<SurfaceLinkProps, 'href'> & {
  /** Discover query, without the leading `?` (e.g. `date=tonight`). */
  readonly query?: string;
  /** City to browse. Defaults to the request's city context. */
  readonly cityCode?: CityCode;
};

/**
 * A link INTO Discover that keeps a signed-in viewer on `app.*` and an
 * anonymous visitor on the city host (WEB-1231 / R25). A client island, so a
 * Server Component can render it without threading surface or session.
 */
export const DiscoverLink = React.forwardRef<HTMLAnchorElement, DiscoverLinkProps>(
  function DiscoverLink({ query, cityCode, ...rest }, ref) {
    const toDiscover = useDiscoverHref(cityCode);
    return <SurfaceLink ref={ref} href={toDiscover(query)} {...rest} />;
  },
);
